import { Component } from '../../../component-classes';

/**
 * Resolves the starting center.x for a newly created PanelItemGroup from the incoming component's catalog defaultPlacement.
 * @param component Component whose catalog defaultPlacement drives the position, when there is one
 * @param panelWidth width of the panel the group is being added to
 * @returns panel-relative center.x, or null when no horizontal default is set
 */
export const getDefaultPlacementCenterXCfn = (component: Component | null, panelWidth: number): number | null => {
	if (!component?.defaultPlacement) return null;

	const { left, right } = component.defaultPlacement;
	const halfPanelWidth = panelWidth / 2;
	const halfComponentWidth = component.size.width / 2;

	if (typeof left === 'number') return -halfPanelWidth + left + halfComponentWidth;
	if (typeof right === 'number') return halfPanelWidth - right - halfComponentWidth;

	return null;
};
